import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import styles from './FormLayout.module.scss';

interface Props {
  header: ReactNode;
  footer: ReactNode;
  children: ReactNode;
  containerClass?: string;
}

export const FormLayout: FC<Props> = ({ header, footer, children, containerClass }) => (
  <section className={styles.root}>
    <header className={styles.header}>{header}</header>
    <div className={clsx(styles.container, containerClass)}>
      <div className={styles.content}>{children}</div>
    </div>
    <footer className={styles.footer}>{footer}</footer>
  </section>
);
